const Api = {
  base: `/${process.env.LENSPIRE_CHANNEL}/wp-json/lenspire/v1/`,
  tiles: 'tiles/',
  ambassadors: 'ambassadors/',
  ambassador: 'ambassador/',
  article: 'article/',
  nav: 'nav/',
  globals: 'global/',
  search: 'search/',
};

export default Api;



// WEBPACK FOOTER //
// ./frontend/js/Base/Config.jsx